function motionEvent(name, target, isExit) {
  return new CustomEvent(name, { detail: { target, isExit } });
}
export {
  motionEvent
};
